import { Component, Input } from '@angular/core';
import { BcContestStatus } from '../../models/BcContest';

@Component({
    selector: 'app-bc-contest-status',
    template: `
<span class="badge text-bg-primary" *ngIf="active">{{'bcContest_statusActive' | translate}}</span>
<span class="badge" *ngIf="value && !active"
        [class.text-bg-success]="value == 'Completed'"
        [class.text-bg-warning]="value == 'Published'"
        [class.text-bg-secondary]="value == 'Draft'"
        [class.text-bg-danger]="value == 'Cancelled'">
    {{'bcContest_status' + value | translate}}
</span>
`
})
export class BcContestStatusComponent {
    @Input() value: BcContestStatus;
    @Input() active: boolean;
}
